import React, { useState, useRef, useEffect } from 'react';
import { Button, Input } from 'reactstrap';
import { observer } from "mobx-react";
import { Enum } from 'helpers';
import './CompactMergeTagsDropdown.css';

const CompactMergeTagsDropdown = observer(({
  atsCategorisedFieldsForMergeTags,
  onTagSelected,
  isDisabled = false,
  isAutomationContact = false,
  buttonText = "Insert merge tag"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  if (isAutomationContact) {
    atsCategorisedFieldsForMergeTags = [...atsCategorisedFieldsForMergeTags, ...Enum.CandidateMergeTagsForContacts];
  }

  const filteredCategories = searchTerm
    ? atsCategorisedFieldsForMergeTags.filter(category =>
      category.atsFields.some(atsField =>
        atsField.displayName.toLowerCase().includes(searchTerm.toLowerCase())))
    : atsCategorisedFieldsForMergeTags;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleTagSelect = (tokenVariable) => {
    onTagSelected(tokenVariable);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="compact-merge-tags-container" ref={dropdownRef}>
      <Button
        color="secondary"
        size="sm"
        className="compact-merge-tags-button"
        disabled={isDisabled}
        onClick={() => setIsOpen(!isOpen)}
      >
        {buttonText}
        <i className={`fa fa-caret-${isOpen ? 'up' : 'down'} ml-1`} />
      </Button>

      {isOpen && (
        <div className="compact-merge-tags-menu">
          <div className="compact-merge-tags-search-container">
            <i className="fa fa-search" aria-hidden="true"></i>
            <Input
              type="search"
              placeholder="Type to search tags"
              className="compact-merge-tags-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>

          <div className="compact-merge-tags-items">
            {filteredCategories.length > 0 ? (
              filteredCategories.map((category, categoryIndex) => (
                <React.Fragment key={categoryIndex}>
                  <div className='compact-merge-tags-divider'></div>
                  <div className="compact-merge-tags-header">{category.categoryType}</div>
                  {category.atsFields
                    .filter(atsField =>
                      atsField.displayName.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((atsField) => (
                      <div
                        className="compact-merge-tags-item"
                        key={atsField.id}
                        onClick={() => handleTagSelect(atsField.tokenVariable)}
                      >
                        <span className="ml-3">{atsField.displayLabel ?? atsField.displayName}</span>
                      </div>
                    ))}
                </React.Fragment>
              ))
            ) : (
              <div className="compact-merge-tags-item">No tags found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
});

export default CompactMergeTagsDropdown;
